module.exports = __webpack_public_path__ + "static/media/qempo_tiendas_logo.0abc5a9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiendas/qempo_tiendas_logo.png
// module id = 2235
// module chunks = 0